import styles from "./UploadInputContainer.module.css";
import { IoCloudUpload } from "react-icons/io5";
import { IoDocumentTextSharp  } from "react-icons/io5";
import CustomCard from "../../Util/CustomCard";
import { FaInfoCircle } from "react-icons/fa";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../../store/global-context";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Tooltip } from 'primereact/tooltip';
import { InputText } from 'primereact/inputtext';
import AuthContext from "../../../store/auth-context";
import axios from 'axios';
import Cookies from "js-cookie";
import { hasDuplicates } from "../../Util/validation";
import { SingleSelectDropdown } from "../../Util/CustomDropdown";
import { useNavigate } from "react-router-dom";
import { getFileSize } from "../../Util/utility";
import { errorMessage } from "../../Util/errorMessage";
import { useDialogIsolation } from "../../Util/useDialogIsolation";
import { saveFile } from "../../Util/download";
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['X-CSRFToken'] = Cookies.get('csrftoken');

const UploadInputContainer = (props) => {
    const navigate = useNavigate();
    const globalCtx = useContext(GlobalContext);
    const authCtx = useContext(AuthContext);
    const fileInput = useRef();
    const [selectedFile, setSelectedFile] = useState("");
    const [isUploading,setIsUploading] = useState(false);
    const [isLoadingColumnList,setIsLoadingColumnList] = useState(false);
    const [isUploadModalVisible,setIsUploadModalVisible] = useState(false);
    const uploadDialogTitle = `Upload ${props.type === "holdings" ? "Holdings" : "Certificate"} Master`;
    // RCMC-23: page behind inert while open, focus to the first field; RCMC-02: named close button
    const uploadDialogIsolation = useDialogIsolation(isUploadModalVisible, uploadDialogTitle);
    const [uploadingFiles,setUploadingFiles] = useState([]);
    const [uploadedFiles,setUploadedFiles] = useState([]);
    const [uploadDetails, setUploadDetails] = useState({});
    const [columnList, setColumnList] = useState([]);

    useEffect(() => {
        axios.get(`/api/operations/get-docs?type=${props.type}&company=${props.company}`, {
            headers: { Authorization: "Bearer " + authCtx.authTokens.access },
          })
        .then(response => {
            setUploadedFiles(response.data.docs_list);
        })
        .catch((e) => {
            globalCtx.raiseAlert(errorMessage(e), "error");
            if(e.response?.status === 401 || e.response?.status === 403){
                window.location = '/login';
            }
            setUploadedFiles([]);
        });
        setUploadDetails(prevState => {return {...prevState,companyId:props.company}});
    },[setUploadedFiles,props.company]);

    useEffect(() => {
        if(props.type === "holdings"){
            setUploadDetails({folio_no:"",isin:"",total_shares:"",pan_no:""});
        } else {
            setUploadDetails({folio_no:"",cert_no:"",shares:""});
        }
    },[])

    const uploadFile = () => {
        const file = selectedFile;
        var fileSize = getFileSize(file);
        const formData = new FormData();
        formData.append("file",file);
        formData.append("type",props.type);
        formData.append("size",fileSize);
        formData.append("company_id",props.company);
        formData.append("column_mapping",JSON.stringify(uploadDetails));
        setUploadingFiles(prevState => [...prevState,file.name]);
        axios.post("/api/operations/upload-docs",formData,{headers: {"Content-Type": "multipart/form-data",Authorization: "Bearer " + authCtx.authTokens.access}}).then(response => {
            if(response.status !== 200){
                alert("Error occurred while uploading the file. Please try again.");
                fileInput.current.value = "";
                setIsUploading(false);
                setSelectedFile("");
                return;
            } 
            setIsUploading(false);
            setUploadedFiles((prevState) => [response.data.doc_details,...prevState]);
            setUploadingFiles(prevState => {prevState.splice(prevState.indexOf(response.data.doc_details.doc_file_name),1);return prevState;});
            fileInput.current.value = "";
            setSelectedFile("");
        }).catch(e => {
            globalCtx.raiseAlert(errorMessage(e), "error");
            if(e.response?.status === 401 || e.response?.status === 403){
                window.location = '/login';
            }
            fileInput.current.value = "";
            setIsUploading(false);
            setSelectedFile("");
            setUploadingFiles(prevState => {prevState.splice(prevState.indexOf(e.config.data.get("file").name),1);return prevState;});
        });
    }

    const onInputChangeHandler = (event) => {
        const file = event.target.files[0];
        if(!props.company){
            alert("Please select a company!");
            fileInput.current.value = "";
            return;
        }
        if(!file) return;
        if(!file.name.endsWith(".xlsx")){
            alert("Invalid file type. Please upload an xlsx file.");
            fileInput.current.value = "";
            return;
        }
        const formData = new FormData();
        formData.append("file",file);
        setIsLoadingColumnList(true);
        axios.post(`/api/operations/get-columns`,formData,{headers: { Authorization: "Bearer " + authCtx.authTokens.access }})
        .then(response => {
            setColumnList(response.data.columns);
            setIsLoadingColumnList(false);
        })
        .catch((e) => {
            globalCtx.raiseAlert(errorMessage(e), "error");
            if(e.response?.status === 401 || e.response?.status === 403){
                window.location = '/login';
            }
            setColumnList([]);
        });
        setIsUploadModalVisible(true);
        setSelectedFile(file);
    }

    const onModalHide = () => {
        setIsUploadModalVisible(false);
        fileInput.current.value = "";
        setUploadDetails({})
    }

    const uploadHoldingsMaster = () => {
        if(!uploadDetails.companyId){
            alert("Select a company!");
            return;
        }
        const columnValues = Object.values(uploadDetails);
        if(hasDuplicates(columnValues)){
            alert("Two fields can't have the same mapping");
            return;
        }
        if(columnValues.filter((item) => item === "").length > 0){
            alert("Please select a valid value for all the columns");
            return;
        }
        setIsUploading(true);
        onModalHide();
        uploadFile();
    }

    const setUpdatedUploadValues= (value) => {
        setUploadDetails((prevState) => {return {...prevState,...value}});
    }

    const downloadFile = (doc_file,doc_file_name) => {
        axios
        .get(`/api/operations/download-docs?doc_file=${doc_file}&doc_file_name=${doc_file_name}`, {
          headers: { Authorization: "Bearer " + authCtx.authTokens.access },responseType: 'blob'
        })
        .then((blob) => {
            // Ticket 22 (Q35): v1.2 left the hand-over's empty <a download> in <body> (Util/download.js)
            saveFile(blob.data, doc_file_name);
        })
        .catch((e) => {
            globalCtx.raiseAlert(errorMessage(e), "error");
            if(e.response?.status === 401 || e.response?.status === 403){
                window.location = '/login';
            }
        });
    }

    return (
        <CustomCard styles={{borderRadius:"20px"}}>
            <form action="#" onClick={() => fileInput.current.click()} className={styles['upload-container']}>
                <input ref={fileInput} type="file" onChange={onInputChangeHandler} className={styles['file-input']} hidden/>
                <IoCloudUpload size="30px" color="white" />
                <div style={{color:"white"}}>{props.message}</div>
            </form>
            <Dialog header={uploadDialogTitle} visible={isUploadModalVisible} style={{ width: "25vw" }} onHide={onModalHide} {...uploadDialogIsolation}>
                {isLoadingColumnList ? <div style={{display:"flex",flexDirection:"column",alignItems:"center",fontSize:"0.8rem"}}><div className={styles['loader']}></div><div>Loading column list from file...</div></div> : (
                    <>
                        <span className="p-float-label"><InputText styles={{width:"100%",marginBottom:"10px"}}  disabled value={props.listOfCompanies && props.company ? props.listOfCompanies.filter(item => item.value===props.company)[0].label : ""} /> <label htmlFor="username">Company</label></span>
                        <div style={{fontSize:"0.8rem",marginBottom:"15px"}}>
                            Map fields to respective columns
                        </div>
                        {props.type === "holdings" ? (
                        <>
                            <SingleSelectDropdown label="Folio No" eleId="folio-no" styles={{width:"100%",marginBottom:"15px"}} selectedValue={uploadDetails.folio_no} setSelectedValue={(value) => setUpdatedUploadValues({folio_no:value})} options={columnList} />
                            <SingleSelectDropdown label="ISIN" eleId="isin" styles={{width:"100%",marginBottom:"15px"}} selectedValue={uploadDetails.isin} setSelectedValue={(value) => setUpdatedUploadValues({isin:value})} options={columnList} />
                            <SingleSelectDropdown label="Total Shares" eleId="total-shares" styles={{width:"100%",marginBottom:"15px"}} selectedValue={uploadDetails.total_shares} setSelectedValue={(value) => setUpdatedUploadValues({total_shares:value})} options={columnList} />
                            <SingleSelectDropdown label="Pan No" eleId="pan-no" styles={{width:"100%",marginBottom:"15px"}} selectedValue={uploadDetails.pan_no} setSelectedValue={(value) => setUpdatedUploadValues({pan_no:value})} options={columnList} />
                        </>
                        ) : (
                        <>
                            <SingleSelectDropdown label="Folio No" eleId="folio-no" styles={{width:"100%",marginBottom:"15px"}} selectedValue={uploadDetails.folio_no} setSelectedValue={(value) => setUpdatedUploadValues({folio_no:value})} options={columnList} />
                            <SingleSelectDropdown label="Cert No" eleId="cert-no" styles={{width:"100%",marginBottom:"15px"}} selectedValue={uploadDetails.cert_no} setSelectedValue={(value) => setUpdatedUploadValues({cert_no:value})} options={columnList} />
                            <SingleSelectDropdown label="Shares" eleId="shares" styles={{width:"100%",marginBottom:"15px"}} selectedValue={uploadDetails.shares} setSelectedValue={(value) => setUpdatedUploadValues({shares:value})} options={columnList} />
                        </>
                        )}
                        <Button label="Upload" raised style={{width:"100%"}} onClick={uploadHoldingsMaster} />
                    </>
                )}
            </Dialog>
            <div className={styles['last-uploaded-docs-container']}>
                <div style={{fontSize:"0.8rem",textAlign:"center"}}>
                    Showing last 10 uploaded files
                </div>
                <section className={styles['progress-area']} style={uploadingFiles.length > 0 ? {marginTop:"10px"} : {}}>
                    {uploadingFiles.map((item) => (
                        <li className={styles['row']}>
                            <IoDocumentTextSharp  size="20px" color="var(--portal-primary)" />
                            <div className={styles['content']}>
                                <div className={styles['details']}>
                                    <span className={styles['file-name']}>{item}</span>
                                    <span className={styles['uploading']}>Uploading...</span>
                                </div>
                                <div className={styles['loader']}></div>
                            </div>
                        </li>
                    ))}
                </section>
                <section className={styles['uploaded-area']}>
                    {uploadedFiles.map((item) => (
                        <li className={styles['row']} key={item.id}>
                            <div className={styles['content']}>
                                <IoDocumentTextSharp size="20px" color="var(--portal-primary)" />
                                <div className={styles['details']}>
                                    <span className={styles['file-name']} title={item.doc_file_name} onClick={() => downloadFile(item.doc_file,item.doc_file_name)}>{item.doc_file_name}</span>
                                    <span className={styles['size']}>{item.doc_size}</span>
                                </div>
                            </div>
                            <FaInfoCircle size="16px" color="var(--portal-primary)" id={`${props.type}-${item.id}`} />
                            <Tooltip  target={`#${props.type}-${item.id}`}>
                                <div style={{display:"flex",flexDirection:"column",fontSize:"0.8rem"}}>
                                    <div><b>File  :</b> {`${item.doc_file_name}`}</div>
                                    <div><b>Size  :</b> {`${item.doc_size}`}</div>
                                    <div><b>Company Name  :</b> {`${item.company_name}`}</div>
                                    <div><b>Uploaded By  :</b> {`${item.last_updated_by.name}`}</div>
                                    <div><b>Uploaded On  :</b> {`${item.last_updated_on}`}</div>
                                </div>
                            </Tooltip>
                        </li>
                    ))}
                </section>
            </div>
        </CustomCard>
    );
}

export default UploadInputContainer;